import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_URL } from "./utils/utils";
import Swal from "sweetalert2";
import Footer from "../components/footer";
import Header from "../components/header";
import SeoLinksSection from "../components/SeoLinksSection";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Email Required",
        text: "Please enter your email address",
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Email",
        text: "Please enter a valid email address",
      });
      return;
    }

    setLoading(true);

    try {
      console.log("Sending password reset request for:", email);

      const response = await fetch(`${API_URL}passenger/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      console.log("Response status:", response.status);
      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Reset Link Sent",
          text:
            data.message ||
            "A password reset link has been sent to your email address. Please check your inbox.",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            data.message ||
            data.error ||
            "Failed to send reset link. Please try again.",
        });
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section
        className="banner pt-10 pb-10"
        style={{ backgroundImage: "url(images/testimonial.png)" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
              <div className="card shadow-lg border-0">
                <div className="card-body p-5">
                  <h3 className="text-center mb-4">Forgot Password</h3>
                  <p className="text-center text-muted mb-4">
                    Enter your email address and we'll send you a link to reset
                    your password.
                  </p>
                  <form onSubmit={handleSubmit} noValidate>
                    <div className="form-group mb-3">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control p-3"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email address"
                        required
                        autoComplete="email"
                      />
                    </div>
                    <div className="form-group mb-3">
                      <button
                        type="submit"
                        className="nir-btn w-100"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send Reset Link"}
                      </button>
                    </div>
                    <div className="text-center">
                      <Link to="/" className="text-decoration-none">
                        <i className="fa fa-arrow-left me-2" /> Back to Home
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SeoLinksSection />
      <Footer />
    </>
  );
}
